import { render, staticRenderFns } from "./DonutChart63.vue?vue&type=template&id=4817f375&scoped=true"
import script from "./DonutChart63.vue?vue&type=script&lang=js"
export * from "./DonutChart63.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4817f375",
  null
  
)

export default component.exports